var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text text-primary text-center"},[_c('t-default-cell',{attrs:{"column":_vm.column,"row":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }